import { common } from '@mtfe/sweet-utils';
import guidFactory from './guidFactory';

const { qsParse } = common;

let _rootPvId; // 用于数据打通关联，query获取
let _frontEndParams; // 前端需要的参数，不透传给后端
let _frontCardParams; // 前卡参数

let _handleCookieDataCache = null;

let _pvPoiParams = null;

const poiIdKeys = ['poi_id_str', 'poiIdStr', 'poi_id', 'poiId'];

// 自执行解析url query
(() => {
    const queryInSearch = qsParse(window.location.search.slice(1));
    const queryInHash = qsParse(window.location.hash.replace(/^[^\?]*/, '').replace(/^\?/, ''));
    const query = { ...queryInSearch, ...queryInHash };
    const { rootPvId, front_end_params, front_card_params, s, um, ...rest } = query;

    _rootPvId = rootPvId || guidFactory.getRootvId();
    _frontEndParams = front_end_params;
    _frontCardParams = front_card_params;
    _pvPoiParams = poiIdKeys.reduce((acc, key) => acc || query[key], '');
})();

const getFrontCardParams = () => {
    return _frontCardParams;
};

const getFrontEndParams = () => {
    return _frontEndParams;
};

const getLxIds = (contentPvId = '') => {
    const valLab = window.__lxPageValLabCustom || {};

    return Object.assign(
        {},
        {
            rootPvId: _rootPvId,
            pagePvId: guidFactory.getPagePvId(),
            pageSessionId: guidFactory.getPageSessionId(),
            outerPvId: _handleCookieDataCache && _handleCookieDataCache.outerPvId ? _handleCookieDataCache.outerPvId : '',
            contentPvId,
            ...valLab,
        },
    );
};

const getLxPoiParams = () => {
    return _pvPoiParams;
};

export { getFrontEndParams, getFrontCardParams, getLxIds, getLxPoiParams };
